import Phaser from "phaser";
import { BootScene } from "./scenes/BootScene.ts";
import { MenuScene } from "./scenes/MenuScene.ts";
import { GarageScene } from "./scenes/GarageScene.ts";
import { StageSelectScene } from "./scenes/StageSelectScene.ts";
import { GameScene } from "./scenes/GameScene.ts";
import { HUDScene } from "./scenes/HUDScene.ts";
import { ResultsScene } from "./scenes/ResultsScene.ts";
import { AchievementsScene } from "./scenes/AchievementsScene.ts";
import { DailyChallengesScene } from "./scenes/DailyChallengesScene.ts";
import { SettingsScene } from "./scenes/SettingsScene.ts";
import { PauseMenuScene } from "./scenes/PauseMenuScene.ts";

const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  parent: "app",
  backgroundColor: "#0f1a24",
  scale: {
    mode: Phaser.Scale.RESIZE,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    width: window.innerWidth,
    height: window.innerHeight,
  },
  physics: {
    default: "matter",
    matter: {
      gravity: { x: 0, y: 1 },
      debug: false,
    },
  },
  scene: [
    BootScene,
    MenuScene,
    GarageScene,
    StageSelectScene,
    GameScene,
    HUDScene,
    ResultsScene,
    AchievementsScene,
    DailyChallengesScene,
    SettingsScene,
    PauseMenuScene,
  ],
};

const game = new Phaser.Game(config);

if (import.meta.env.DEV) {
  (window as unknown as { __game: Phaser.Game }).__game = game;
}

if ("serviceWorker" in navigator) {
  if (import.meta.env.PROD) {
    window.addEventListener("load", () => {
      void navigator.serviceWorker.register("./sw.js").catch(() => {
        // Offline install is optional and should fail gracefully in unsupported contexts.
      });
    });
  } else {
    // A service worker left over from a previous session would serve stale dev files.
    void navigator.serviceWorker.getRegistrations().then((regs) => regs.forEach((r) => void r.unregister()));
  }
}

// Auto-pause when the tab loses focus (spec requirement), showing the pause menu so the
// player resumes deliberately.
document.addEventListener("visibilitychange", () => {
  if (!document.hidden) return;
  const gameScene = game.scene.getScene("GameScene") as GameScene | null;
  if (gameScene && gameScene.scene.isActive()) gameScene.openPauseMenu();
});
